 <template>
  <div>
    <div class="headings">
      <div class="payment-breakdown title" @click="changeDisplay('PAYMENT_BREAKDOWN')">
        <span>Payment Breakdown</span>
      </div>
      <div class="amortization-schedule title" @click="changeDisplay('AMORTIZATION_SCHEDULE')">
        <span>Amortization Schedule</span>
      </div>
    </div>
    <div class="selection-bar">
      <div class="bar" :class="state.CURRENT_DISPLAY === 'PAYMENT_BREAKDOWN' ? 'active' : ''"></div>
      <div class="bar" :class="state.CURRENT_DISPLAY === 'AMORTIZATION_SCHEDULE' ? 'active' : ''"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";

import { GETTERS, MUTATIONS } from "../storeConstants";

const { CHANGE } = MUTATIONS;

export default {
  methods: {
    ...mapMutations([CHANGE]),
    changeDisplay(display) {
      this.CHANGE({ target: "CURRENT_DISPLAY", value: display });
    }
  },
  computed: {
    ...mapState({
      state: state => state.base
    })
  }
};
</script>
<style scoped lang="scss">
.tabs {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: calc(100% - 26px);

  > * {
    left: -2px;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
  }
  .title {
    width: 50%;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: normal;
    text-align: left;
    color: #282828;
    &:hover {
      cursor: pointer;
    }
  }
  .bar {
    height: 5px;
    width: 100%;
  }

  @media (max-width: 767px) {
    .bar:nth-child(1).active {
      width: 254px;
    }
    .bar:nth-child(2).active {
      width: 297px;
    }
  }
  @media (min-width: 768px) {
    .bar:nth-child(1).active {
      width: 179px;
    }
    .bar:nth-child(2).active {
      width: 198px;
    }
  }
  @media (min-width: 1024px) {
    .bar:nth-child(1).active {
      width: 191px;
    }
    .bar:nth-child(2).active {
      width: 213px;
    }
  }
  @media (min-width: 1350px) {
    .bar:nth-child(1).active {
      width: 175px;
    }
    .bar:nth-child(2).active {
      width: 192px;
    }
  }
  .active {
    background-image: linear-gradient(to right, #60c5b7, #acd14c);
  }
  .selection-bar {
    height: 5px;
    border: solid 1px var(--white-three);
    border-bottom: 1px solid #f3f3f3;
  }

  .amortization-schedule {
    text-align: right;
  }
  .payment-breakdown span {
    padding: 10px 3.8px;
    float: left;
    display: flex;
    background: linear-gradient(to right, #60c5b7, #acd14c);
    color: #fff;
    cursor: pointer;
    border-radius: 4px 4px 0 0;
    box-shadow: 1px 1px 6px #ccc;
  }
  .amortization-schedule span {
    padding: 10px 3.8px;
    float: right;
    display: flex;
    background: linear-gradient(to right, #60c5b7, #acd14c);
    color: #fff;
    cursor: pointer;
    border-radius: 4px 4px 0 0;
    box-shadow: -1px 1px 6px #ccc;
  }
}
</style>